import { createTypes } from "reduxsauce";

export default createTypes(
    `
    FETCH_CITY_LIST_SUCCESS
    GET_DRIVA_TIMEOUT_CONFIG_SUCCESS
    GET_DRIVA_TIMEOUT_CONFIG_FAILURE
    GET_DRIVA_TIMEOUT_CONFIG_REQUEST

    GET_IN_HOUSE_FINANCE_TIMEOUT_CONFIG_SUCCESS
    GET_IN_HOUSE_FINANCE_TIMEOUT_CONFIG_FAILURE
    GET_IN_HOUSE_FINANCE_TIMEOUT_CONFIG_REQUEST

    IN_HOUSE_FINANCE_API_POLL_SUCCESS
    IN_HOUSE_FINANCE_API_POLL_FAILURE

    DRIVA_API_POLL_SUCCESS
    DRIVA_API_POLL_FAILURE

    DRIVA_API_CALLBACK_SUCCESS
    DRIVA_API_CALLBACK_FAILURE

    FETCH_CONFIG_INIT
    FETCH_CONFIG_SUCCESS
    FETCH_CONFIG_FAILURE

    FETCH_BODY_TYPE_CONFIG_INIT
    FETCH_BODY_TYPE_CONFIG_SUCCESS
    FETCH_BODY_TYPE_CONFIG_FAILURE

    LOAN_APP_TOGGLE_CONFIG_REQUEST
    LOAN_APP_TOGGLE_CONFIG_SUCCESS
    LOAN_APP_TOGGLE_CONFIG_FAILURE
    FETCH_CONFIG_WITH_TYPE_INIT
    FETCH_CONFIG_WITH_TYPE_SUCCESS
    FETCH_CONFIG_WITH_TYPE_FAILURE

    FETCH_TEST_DRIVE_CMS_CONFIG_INIT
    FETCH_TEST_DRIVE_CMS_CONFIG_SUCCESS
    FETCH_TEST_DRIVE_CMS_CONFIG_FAILURE
    
    FETCH_CHECKIN_WORKFLOW_INIT
    FETCH_CHECKIN_WORKFLOW_SUCCESS
    FETCH_CHECKIN_WORKFLOW_FAILURE
`,
    {
        prefix: "configssr/"
    }
);
